import script from "./LogistSummaryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LogistSummaryPage.vue?vue&type=script&setup=true&lang=js"

import "./LogistSummaryPage.vue?vue&type=style&index=0&id=20ad18f6&scoped=true&lang=css"
import "./LogistSummaryPage.vue?vue&type=style&index=1&id=20ad18f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ad18f6"]])

export default __exports__